<template>
  <div class="manage-devices-container">
    <ContentContainerNavbar :title="$t('i18n.manageDevicesTitle', { records: filteredDevices().length })" button :buttonText="$t('i18n.manageDevicesButtonText')" buttonEvent="open-create-device-modal-btn" @open-create-device-modal-btn="openCreateDeviceModal" />
    <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
    <v-table v-else class="table" fixed-header :hover="deviceList.length !== 0">
      <thead>
        <tr>
          <th class="text-left font-weight-black cursor-pointer checkbox-cell">
            <v-icon class="cursor-pointer pr-6" :icon="filterActive ? 'mdi-filter-remove' : 'mdi-filter-menu'" @click="filterActive = !filterActive"></v-icon>
            {{ $t('i18n.name') }}
          </th>
          <th class="text-left font-weight-black">
            {{ $t('i18n.description') }}
          </th>
          <th class="text-left font-weight-black">
            {{ $t('i18n.location') }}
          </th>
          <!-- <th class="text-left font-weight-black">
            {{ $t('i18n.type') }}
          </th> -->
          <!-- <th class="text-left font-weight-black">
            {{ $t('i18n.completionRedirectUrl') }}
          </th> -->
          <th class="text-left font-weight-black">
            {{ $t('i18n.ipAddress') }}
          </th>
          <!-- <th class="text-left font-weight-black">
            {{ $t('i18n.shortURL') }}
          </th> -->
          <th class="text-left font-weight-black">
            {{ $t('i18n.associatedForm') }}
          </th>
          <th class="text-left font-weight-black">
            {{ $t('i18n.uniqueIdentifier') }}
          </th>
          <th class="text-left font-weight-black">
            {{ $t('i18n.appVersion') }}
          </th>
          <th class="text-left font-weight-black">
            {{ $t('i18n.lastHeartbeat') }}
          </th>
          <th class="text-left font-weight-black">
            {{ $t('i18n.actions') }}
          </th>
        </tr>
        <tr v-if="filterActive">
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.name" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.description" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.location" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.ip_address" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.form" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.uuid" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.app_version" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black">
            <v-text-field v-model="filters.last_heartbeat" density="compact" variant="outlined" :hide-details="true" clearable></v-text-field>
          </th>
          <th class="text-left font-weight-black"></th>
        </tr>
      </thead>
      <tbody v-if="deviceList.length !== 0">
        <tr v-for="(device, index) in filteredDevices()" :key="index" class="text-left">
          <td>{{ device.name }}</td>
          <td>{{ device.description }}</td>
          <td>{{ device.location }}</td>
          <td>{{ device.ip_address }}</td>
          <td>{{ device.form_id !== null ? formName(device.form_id) : null }}</td>
          <td>{{ device.uuid }}</td>
          <td>{{ device.app_version }}</td>
          <td>
            <div class="heartbeat-cell">
              <v-icon v-if="showAlertIcon(device.last_heartbeat)" color="warning" icon="mdi-alert-circle"></v-icon>
              <v-tooltip v-if="showAlertIcon(device.last_heartbeat)" activator="parent" location="start">
                {{ $t('i18n.heartbeatAlert', { minutes: heartbeatAlertMinutes }) }}
              </v-tooltip>
              <span>{{ formatHeartbeat(device.last_heartbeat) }} </span>
            </div>
          </td>
          <td class="text-left px-0">
            <!-- Qr Code download -->
            <v-btn v-if="deviceTypeName(device.type_id) === 'QRCODE'" @click="downloadQRCode(device)" @download-complete="resetQRModal()" class="cursor-pointer" variant="text" size="small" icon>
              <v-icon icon="mdi-qrcode-scan" size="large"></v-icon>
              <v-tooltip activator="parent" location="start">
                {{ $t('i18n.downloadQRCode') }}
              </v-tooltip>
            </v-btn>
            <!-- ou Refresh content -->
            <v-btn v-else class="cursor-pointer" variant="text" size="small" icon @click="refreshDeviceContent(index)">
              <v-icon icon="mdi-play"></v-icon>
              <v-tooltip activator="parent" location="start">
                {{ $t('i18n.btnRefreshContent') }}
              </v-tooltip>
            </v-btn>
            <v-btn class="cursor-pointer" variant="text" size="small" icon @click="openEditDeviceModal(index)">
              <!-- <v-icon icon="mdi-square-edit-outline"></v-icon> -->
              <v-icon size="small" icon="$GoRateEdit"></v-icon>
              <v-tooltip activator="parent" location="start">
                {{ $t('i18n.btnEditDevice') }}
              </v-tooltip>
            </v-btn>
            <v-btn class="cursor-pointer" variant="text" size="small" icon @click="openDeleteDeviceModal(index)">
              <!-- <v-icon icon="mdi-delete-outline"></v-icon> -->
              <v-icon size="small" icon="$GoRateDeleteOutline"></v-icon>
              <v-tooltip activator="parent" location="start">
                {{ $t('i18n.btnDeleteDevice') }}
              </v-tooltip>
            </v-btn>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="no-hover">
          <td colspan="9" class="text-center"> {{ $t('i18n.noDataAvailable') }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
  <!--
   Modals are below
  -->
  <QrCodeModal v-if="qrCodeModalVisible && selectedQRCode" :tinyUrl="selectedQRCode.short_url" :label="selectedQRCode.name" logoName="icon-only.png" @download-complete="resetQRModal()" @qrcode-error="appStore.addAlert('error', 'Error creating QR Code.')" />
  <!--
   Dialogs are below
  -->
  <v-dialog v-model="createDeviceModalIsActive" max-width="400">
    <CreateDeviceModal :currentDeviceList="deviceList" @close-modal="closeCreateDeviceModal" />
  </v-dialog>
  <v-dialog v-model="editDeviceModalIsActive" max-width="400">
    <EditDeviceModal v-if="selectedDevice" :currentDeviceList="deviceList" :device="selectedDevice" @close-modal="closeEditDeviceModal" />
  </v-dialog>
  <v-dialog v-model="deleteDeviceModalIsActive" max-width="400">
    <DeleteDeviceModal :deviceID="selectedDeviceID" @close-modal="closeDeleteDeviceModal" />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Device, DeviceType, Form } from '@/utils/DataTypes'

import { api, findDeviceTypeById, formatHeartbeat } from '../../utils/HelperFunctions'

import ContentContainerNavbar from '../navbars/ContentContainerNavbar.vue'
import CreateDeviceModal from '../modals/device_modals/CreateDeviceModal.vue'
import EditDeviceModal from '../modals/device_modals/EditDeviceModal.vue'
import DeleteDeviceModal from '../modals/device_modals/DeleteDeviceModal.vue'
import QrCodeModal from '../modals/QrCodeModal.vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'ManageDevices',
  setup() {
    const router = useRouter()
    const appStore = useAppStore()
    return {
      router,
      appStore,
      formatHeartbeat
    }
  },
  components: {
    ContentContainerNavbar,
    CreateDeviceModal,
    EditDeviceModal,
    DeleteDeviceModal,
    QrCodeModal
  },
  async mounted() {
    await this.getFormList()
    this.deviceTypeList = this.appStore.getAppState.deviceTypeList
    await this.getDeviceList()
    this.loading = false
  },
  data() {
    return {
      formList: [] as Form[],

      selectedDeviceID: -1,
      selectedDevice: null as Device | null,

      createDeviceModalIsActive: false,
      editDeviceModalIsActive: false,
      deleteDeviceModalIsActive: false,
      deviceAlertIsActive: false,
      filterActive: false,
      loading: true,
      qrCodeModalVisible: false,

      deviceTypeList: [] as DeviceType[],
      deviceList: [] as Device[],

      filters: {
        name: '',
        description: '',
        location: '',
        type: '',
        completion_redirect_url: '',
        ip_address: '',
        short_url: '',
        form: '',
        uuid: '',
        app_version: '',
        last_heartbeat: ''
      },

      selectedQRCode: null as Device | null,

      heartbeatAlertMinutes: 15,

      alertMessage: '',
      alertStyle: ''
    }
  },
  methods: {
    async closeCreateDeviceModal() {
      await this.getDeviceList()
      this.createDeviceModalIsActive = false
    },
    async closeEditDeviceModal() {
      await this.getDeviceList()
      this.editDeviceModalIsActive = false
    },
    async closeDeleteDeviceModal() {
      await this.getDeviceList()
      this.deleteDeviceModalIsActive = false
    },
    async getFormList() {
      try {
        const url = '/forms-simplified'
        const getFormListResponse = await api(url, 'get')

        if (!getFormListResponse) return

        this.formList = getFormListResponse.data
      } catch (error) {
        this.appStore.addAlert('error', 'Couldn\'t get form list.')
      }
    },
    async getDeviceList() {
      try {
        const url = '/devices'
        const getDeviceListResponse = await api(url, 'get')

        if (!getDeviceListResponse) return

        this.deviceList = getDeviceListResponse.data
        this.appStore.setDeviceList(getDeviceListResponse.data)
      } catch (error) {
        this.appStore.addAlert('error', 'Couldn\'t get device list.')
      }
    },
    navigate(routeName: string) {
      this.router.push({ name: routeName })
    },
    formName(formID: number | undefined) {
      const form = this.formList.find(form => form.id === formID)
      return form ? form.name : null
    },
    deviceTypeName(typeID: number | null) {
      if (typeID === null) {
        return 'NULL'
      }
      const itemTypeName = findDeviceTypeById(this.deviceTypeList, typeID)
      if (itemTypeName === null) {
        return 'N/A'
      } else {
        return itemTypeName
      }
    },
    refreshDeviceContent(index: number) {
      // TODO: usar index para refrescar só o device selecionado
      const url = '/devices/refresh-content'
      api(url, 'post')
        .then(() => {
          this.appStore.addAlert('info', 'Content refresh requested.')
        })
        .catch(() => {
          this.appStore.addAlert('error', 'Couldn\'t request content refresh.')
        })
    },
    openEditDeviceModal(index: number) {
      this.deviceAlertIsActive = false
      this.editDeviceModalIsActive = true
      const filteredDevices = this.filteredDevices()
      this.selectedDevice = filteredDevices[index]
    },
    openDeleteDeviceModal(index: number) {
      this.deviceAlertIsActive = false
      const filteredDevices = this.filteredDevices()
      const device = filteredDevices[index]
      this.selectedDeviceID = device?.id ?? -1
      this.deleteDeviceModalIsActive = true
    },
    openCreateDeviceModal() {
      this.deviceAlertIsActive = false
      this.createDeviceModalIsActive = true
    },
    filteredDevices() {
      let filteredDevices = this.deviceList as Device[]
      if (this.filters.name) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.name.toLowerCase().includes(this.filters.name.toLowerCase())
        )
      }
      if (this.filters.description) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.description?.toLowerCase().includes(this.filters.description.toLowerCase())
        )
      }
      if (this.filters.location) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.location?.toLowerCase().includes(this.filters.location.toLowerCase())
        )
      }
      if (this.filters.type) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          this.deviceTypeName(device.type_id).toLowerCase().includes(this.filters.type.toLowerCase())
        )
      }
      if (this.filters.completion_redirect_url) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.completion_redirect_url?.toLowerCase().includes(this.filters.completion_redirect_url.toLowerCase())
        )
      }
      if (this.filters.ip_address) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.ip_address?.toLowerCase().includes(this.filters.ip_address.toLowerCase())
        )
      }
      if (this.filters.short_url) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.short_url?.toLowerCase().includes(this.filters.short_url.toLowerCase())
        )
      }
      if (this.filters.form) {
        filteredDevices = filteredDevices.filter((device) => {
          if (device.form_id !== undefined && device.form_id) {
            return this.formName(device.form_id)?.toLowerCase().includes(this.filters.form.toLowerCase())
          }
          return null
        })
      }
      if (this.filters.uuid) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.uuid.toLowerCase().includes(this.filters.uuid.toLowerCase())
        )
      }
      if (this.filters.app_version) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.app_version?.toLowerCase().includes(this.filters.app_version.toLowerCase())
        )
      }
      if (this.filters.last_heartbeat) {
        filteredDevices = filteredDevices.filter((device: Device) =>
          device.last_heartbeat?.toLowerCase().includes(this.filters.last_heartbeat.toLowerCase())
        )
      }
      return filteredDevices.sort((a: Device, b: Device) => {
        if (a.id == null && b.id == null) return 0
        if (a.id == null) return 1
        if (b.id == null) return -1
        return b.id - a.id // DESC
      })
    },
    resetQRModal() {
      this.selectedQRCode = null
      this.qrCodeModalVisible = false
    },
    downloadQRCode(selectedQRCode: Device) {
      this.selectedQRCode = selectedQRCode
      this.qrCodeModalVisible = true
    },
    showAlertIcon(lastHeartbeat: string | null | undefined): boolean {
      if (!lastHeartbeat) {
        return true // Show alert icon if lastHeartbeat is null or undefined
      }
      const heartbeat = dayjs(lastHeartbeat)
      if (!heartbeat.isValid()) {
        return true // Show alert icon if lastHeartbeat is invalid
      }
      const now = dayjs()
      const diffInMinutes = now.diff(heartbeat, 'minute')
      return diffInMinutes > this.heartbeatAlertMinutes
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.heartbeat-cell {
  display: flex;
  align-items: center;
  gap: 0.2em;
  cursor: default;
}

.manage-devices-container {
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;

  box-shadow: 2px 0 15px 0 rgba(0, 0, 0, 0.08);

  .table {
    margin: 1.0em;
    padding: 1.0em 2.0em;
    border-radius: 15px;
    overflow-y: auto;

    .checkbox-cell {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: left;
      align-items: center;
    }
  }
}
</style>
